<template>
  <div>
    <v-snackbar
      :value="value"
      absolute
      right
      :timeout="timeout"
      color="success"
      top
    >
      data berhasil di upload
    </v-snackbar>

    <v-expansion-panels class="mt-5">
      <v-expansion-panel
        
      >
        <v-expansion-panel-header>Filtering Data</v-expansion-panel-header>
        <v-expansion-panel-content>
      <v-row class="px-5">
        <v-col cols="12" md="8" sm="12">
          <v-file-input
            class="mt-2"
            v-model="filename"
            accept=".xlsx"
            id="excel_target"
            placeholder="format upload wajib .xlsx"
            ref="post_title"
            @change="impexcel()"
          ></v-file-input>
        </v-col>
        <v-col cols="6" md="2" class="mt-5">
          <v-btn
            class="ml-2"
            color="#5E50A1"
            :loading="loading"
            :disabled="disable"
            @click="postData"
            style="color:#fff"
          >
            UPLOAD FILE
          </v-btn>
        </v-col>
        <v-col cols="6" md="2" class="mt-5">
         <SampleExcel :sheets="sheet" :fname="fname"/>
          
        </v-col>
      </v-row>

      <v-row class="px-5">
     
          <v-col
            md="2"
          >
          <v-text-field
              label="adminhub"
              hide-details
              :value="filterQry.qryAdminHub"
              @change="filterAdminHub"
            ></v-text-field>
        </v-col>
        <v-col
          md="2"
        >
          <v-menu
            v-model="menuDateFrom"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            min-width="290px"
          > 

            <template v-slot:activator="{ on }">
              <v-text-field
                label="Date From"
                v-model="dateFrom"
                prepend-inner-icon="mdi-calendar"
                :value="filterQry.qryDateFrom"
                @change="filterDateFrom"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateFrom" @input="menuDateFrom = false"></v-date-picker>

          </v-menu>
          
        </v-col>
        <v-col
          md="2"
        >
          
          <v-menu
            v-model="menuDateTo"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            min-width="290px"
          > 

            <template v-slot:activator="{ on }">
              <v-text-field
                label="Date To"
                v-model="dateTo"
                prepend-inner-icon="mdi-calendar"
                :value="filterQry.qryDateTo"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateTo" @input="menuDateTo = false"></v-date-picker>

          </v-menu>

        </v-col>
            <v-btn @click="filterItems" style="background-color:rgb(94, 80, 161);color:white" class="mt-5">Filter</v-btn>
            <v-btn @click="deleteFilter" class="ml-1 warning mt-5">Hapus</v-btn>
            <!-- <v-btn @click="filterItemsForBackup" class="ml-1 success">Backup Data</v-btn> -->
            <ExportTable class="ml-1 mt-5" :sheets="exportdata" :fname="filenameBackup" v-show="vBtn"/>
        </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    
      <v-skeleton-loader v-if="firstLoad" :loading="loading" type="table"></v-skeleton-loader>
      <v-row class="mt-5">
        <v-col
         
          cols="3"
          sm="2"
        >
          <v-select
            :items="showData"
            label="show"
            v-show="!firstLoad"
            outlined
            :value="defaultShow"
            @input="handleFilterShowData"
          ></v-select>
    </v-col>
    <v-col  
     
      cols="3"
      sm="2">
      <p v-show="!firstLoad" class="mx-2 mt-3">Total Data :{{totalData}}</p>
    </v-col>
    
      </v-row>
    <v-data-table
      dense
      :search="search"
      id="header"
      :headers="headers"
      :items="data"
      v-show="!firstLoad"
      :fixed-header="true"
      item-key="no"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer=""
      @page-count="pageCount = $event"
      class="mt-5 elevation-5"
      style="padding: 15px"
      :options.sync="options"
    >
      <template v-slot:item="row">
        <tr>
          <!-- <td>{{row.index}}</td> -->
          <td>{{ row.item.Tanggal.substring(0,10)}}</td>
          <td>{{ row.item.Ph }}</td>
          <td>{{ row.item.IncentiveHero}}</td>
          <td>{{ row.item.Phl }}</td>
          <td>{{ row.item.LmCostAtsOutbound }}</td>
          <td>{{ row.item.ParkingFmLm }}</td>
          <td>{{ row.item.LinehaulCostOfDelivery }}</td>
          <td>{{ row.item.FeederLinehaulByPaxel }}</td>
          <td>{{ row.item.OtherCostOfDelivery }}</td>
          <td>{{ row.item.PpCost }}</td>
          <td>{{ row.item.EquipmentHero }}</td>
          <td>{{ row.item.ConsumablesHero }}</td>
          <td>{{ row.item.SalariesBenefit }}</td>
          <td>{{ row.item.Bpjs }}</td>
          <td>{{ row.item.Medical }}</td>
          <td>{{ row.item.Utilities }}</td>
          <td>{{ row.item.RentalPh }}</td>
          <td>{{ row.item.Supplies }}</td>
          <td>{{ row.item.Claims }}</td>
          <td>{{ row.item.PhConsumables }}</td>
          <td>{{ row.item.PhMaintenance }}</td>
          <td>{{ row.item.OfficeEquipment }}</td>
          <td>{{ row.item.Marketing }}</td>
          <td>{{ row.item.ProfessionalFee }}</td>
          <td>{{ row.item.Others }}</td>
          <td>{{ row.item.Class }}</td>
          <td>{{ row.item.UploadedBy }}</td>
          <td>
            <div style="padding: 5px">
              <v-btn v-model="mirrorId" color="red" small @click="delUpload(row.item.Id)"
                ><v-icon small color="white">
                  mdi-delete
                </v-icon></v-btn
              >
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <div style="display: flex; justify-content: end; margin-top: 20px">
      <p class="mt-2" v-show="!firstLoad">page {{ page }} to {{ pageCount }}</p>
      <v-pagination
        v-show="!firstLoad"
        v-model="page"
        :length="RecordsTotal"
        :total-visible="5"
        color="#5E50A1"
        :options.sync="options"
        @input="handlePageChange"
      >
      </v-pagination>
    </div>
  </div>
</template>
<script>
import readXlsFile from "read-excel-file";
import SampleExcel from "@/components/SampleExcel.vue";
import ExportTable from "@/components/ExportTable.vue";
import moment from "moment";
import DatePick from 'vue-date-pick';

export default {
  props:['sheet','fname'],
  components:{
    SampleExcel,
    ExportTable,
    DatePick,
  },
  data: () => ({
    timeout: 3000,
    range: [moment().format('YYYY-MM-DD'), moment().add(4, 'days').format('YYYY-MM-DD')],
    dateFrom: moment().format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD'),
    search:'',
    vBtn:true,
    filenameBackup:"expanse_back_up.xlsx",
    firstLoad: true,
    filename: null,
    mirrorId: [],
    page: 1,
    defaultShow:100,
    showData:[15,25,50,100],
    RecordsTotal:null,
    RecordsFiltered:null,
    itemsPerPage: null,
    totalData:null,
    options: {},
    value: false,
    idSegment: [],
    disable: false,
    pageCount: 0,
    itemsPerPage: null,
    items: null,
    exportdata:[{
      name: "SheetOne",  
      data: null
    }],
    loading: false,
    headers: [
      { id: 2, text: "Tanggal", value: "Tanggal" },
      { id: 3, text: "Ph", value: "Ph" },
      { id: 4, text: "Incentive Hero", value: "incentive_hero" },
      { id: 5, text: "Phl", value: "phl" },
      { id: 6, text: "LmCostAtsOutbound", value: "LmCostAtsOutbound" },
      { id: 7, text: "ParkingFmLm", value: "ParkingFmLm" },
      { id: 8, text: "LinehaulCostOfDelivery", value: "LinehaulCostOfDelivery" },
      { id: 9, text: "FeederLinehaulByPaxel", value: "FeederLinehaulByPaxel" },
      { id: 10, text: "OtherCostOfDelivery", value: "OtherCostOfDelivery" },
      { id: 11, text: "PpCost", value: "PpCost" },
      { id: 12, text: "EquipmentHero", value: "EquipmentHero" },
      { id: 13, text: "ConsumablesHero", value: "ConsumablesHero" },
      { id: 14, text: "SalariesBenefit", value: "SalariesBenefit" },
      { id: 15, text: "Bpjs", value: "Bpjs" },
      { id: 16, text: "Medical", value: "Medical" },
      { id: 17, text: "Utilities", value: "Utilities" },
      { id: 18, text: "RentalPh", value: "RentalPh" },
      { id: 19, text: "Supplies", value: "Supplies" },
      { id: 20, text: "Claims", value: "Claims" },
      { id: 21, text: "PhConsumables", value: "PhConsumables" },
      { id: 22, text: "PhMaintenance", value: "PhMaintenance" },
      { id: 23, text: "OfficeEquipment", value: "OfficeEquipment" },
      { id: 24, text: "Marketing", value: "Marketing" },
      { id: 25, text: "ProfessionalFee", value: "ProfessionalFee" },
      { id: 26, text: "Others", value: "Others" },
      { id: 27, text: "Class", value: "Class" },
      { id: 28, text: "Uploaded By", value: "UploadedBy" },
      { id: 29, text: "Action", value: "butn" },
    ],
    data: [],
    filterQry: {
      qryAdminHub: "",
    },
    pickDate: false,
    useOnFocus: true,
    menuDateFrom: false,
    menuDateTo: false,
  }),
  watch: {
    options: {
      handler() {
        console.log("options watcher called");
        this.getItem();
      },
      deep: true,
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
  },
  methods: {
    getItem(x) {
      const length = x.limit
      this.$store
        .dispatch("getUploadDataExpensePnl",x)
        .then((response) => {
          if (response.data.code == 200) {
            const item = response.data.data;
            if(item.records.length == 0){
                  this.data = []
                  this.totalData = 0
                  this.RecordsTotal =1
                  this.exportdata[0].data = [{}]
                  this.vBtn=false
              }
            this.firstLoad=false
            let z = item.RecordsFiltered
              if (length !== 0) {
                z = item.RecordsTotal / length
              }
             
              this.itemsPerPage = item.RecordsFiltered
              this.RecordsTotal = Math.ceil(z)
              this.data = item.records  
              this.exportdata[0].data = item.records 
              this.totalData = item.RecordsTotal
          }
        })
        .catch(function (error) {});
    },
    getItemForBackup(x) {
      //console.log("get Item" + JSON.stringify(x))
      const length = x.limit
      this.$store
        .dispatch("getUploadDataExpensePnl",x)
        .then((response) => {
          //console.log( response.data.data)
          if (response.data.code == 200) {
           
            const item = response.data.data;
            if(item.records.length == 0){
              this.exportdata[0].data = [{}]
              this.vBtn=true
              //alert("data kosong")
            } else {
              this.exportdata[0].data = item.records 
              this.vBtn=true
            }
          }
        })
        .catch(function (error) {});
    },
    formatDate(value) {
      //console.log("ini moment " + value)
      return moment(value).format("YYYY-MM-DD")
    },
    impexcel() {
      const input = document.getElementById("excel_target");
      readXlsFile(input.files[0]).then((rows) => {
        this.items = rows;
        let keys = this.items[0];

        let newArr = this.items.slice(1, this.items.length);

        let formatted = [],
          data = newArr,
          cols = keys,
          l = cols.length;
        for (let i = 0; i < data.length; i++) {
          let d = data[i],
           
            o = {};
          for (let j = 0; j < l; j++) o[cols[j]] = d[j];

          const check = []
          if(o.Tanggal == undefined){
            alert("check format tangal")
            this.$router.go(this.$router.currentRoute);

          }
          for(let i=0;i<o.Tanggal.length;i++){
            if(o.Tanggal[i] == "-") {
              check.push(o.Tanggal[i])

            }     
          }
          if(check.length < 2){
            alert("format tanggal salah")
            this.$router.go(this.$router.currentRoute);
          }
          let checkTanggal = o.Tanggal.split("-")
          if(checkTanggal[0].length !=4){
            alert("format tahun salah "+ o.Tanggal)
            this.$router.go(this.$router.currentRoute);
          }
          if(checkTanggal[1] > 12){
            alert("format bulan salah "+o.Tanggal)
            this.$router.go(this.$router.currentRoute);
          }     
           formatted.push(o);
          // console.log(JSON.stringify(formatted))
        }
        this.items = formatted    
      });
    },
    postData() {
      const data = { items: this.items };
      this.loading = true;
      if (this.filename) {
        const data = { items: this.items };
        this.loading = true;
        this.disable = false;
        this.$store
          .dispatch("postUploadDataExpensePnl", data)
          .then((response) => {
            if (response.status == 201 || response.status == 200) {
              this.value = true;
              this.filename = null;

              setTimeout(() => (this.loading = false), 2000);
              this.$router.go(this.$router.currentRoute);
            }
          })
          .catch(function (error) {
            alert("Data Gagal di Upload")
            console.log(error);
            this.$router.go(this.$router.currentRoute);
          });
      } else {
        this.loading = true
        alert("upload data tidak boleh kosong") 
        this.$router.go(this.$router.currentRoute);
      }
    },
    delUpload(id) {
      this.$swal({
        title: "Hapus Data? ",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#5E50A1",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("delUploadDataExpensePnl", id).then((response) => {
            console.log(response);
            this.$swal("Berhasil dihapus").then((result) => {
              console.log(result);
              if (result.value) {
                this.$router.go(this.$router.currentRoute);
              }
            });
          });
        }
      });
    },
    deleteFilter(){
      this.filterQry.qryAdminHub  = ""
      this.dateFrom  = ""
      this.dateTo  = ""
      this.vBtn=true
      this.filterItemsForBackup()
      this.getItem({limit:this.defaultShow,page:1,admin_hub:this.filterQry.qryAdminHub,date_from:this.dateFrom,date_to:this.dateTo})
    },
    filterAdminHub(val) {
      this.filterQry.qryAdminHub = val;
     
    },
    filterDateFrom(val){
     
      this.filterQry.qryDateFrom = this.dateFrom
    },
    filterItems() {
      this.getItem({limit:this.defaultShow,page:1,admin_hub:this.filterQry.qryAdminHub,date_from:this.dateFrom,date_to:this.dateTo})
    },
    filterItemsForBackup() {
      this.getItemForBackup({limit:-1,page:1,admin_hub:this.filterQry.qryAdminHub,date_from:this.dateFrom,date_to:this.dateTo})
    },
    handlePageChange(value) {
      let payload={limit:this.defaultShow,page:value,origin:this.filterQry.qryOrigin,destination:this.filterQry.qryDest,service:this.filterQry.qryService}
      this.page = payload.page
      this.getItem(payload)
    },
    handleFilterShowData(x){
      console.log(this.page)
      let payload={limit:x,page:1,admin_hub:this.filterQry.qryAdminHub,date_from:this.dateFrom,date_to:this.dateTo}
      this.defaultShow = x
      this.page=1
      this.getItem(payload)
    }
  },
  mounted() {
    this.getItem({limit:this.defaultShow,page:1,admin_hub:this.filterQry.qryAdminHub,date_from:"",date_to:""});
    this.filterItemsForBackup()
  },
};
</script>
<style scoped>
.v-input__slot {
  min-height: 45px !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.875rem;
    padding: 0px 7px;
    font-size: 12px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th{
  padding: 0 30px !important;
}
</style>